module.exports = __webpack_public_path__ + "img/js.9c8cdd8e.png";